import { render, staticRenderFns } from "./ticketManageTabs.vue?vue&type=template&id=05328409"
import script from "./ticketManageTabs.vue?vue&type=script&lang=js"
export * from "./ticketManageTabs.vue?vue&type=script&lang=js"
import style0 from "./ticketManageTabs.vue?vue&type=style&index=0&id=05328409&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports